import axios from "axios";

let currentAudio = null;
window.ttsStatus = {
  playing: false,
  finished: true,
  cached: false,
  text: ""
};
export const stopSpeechKokoro = () => {
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }

  window.ttsStatus.playing = false;
  window.ttsStatus.finished = true;
};

export const playSpeechKokoro = async (text) => {
  try {
    // Stop previous speech
    stopSpeechKokoro();
    window.ttsStatus.playing = true;
    window.ttsStatus.finished = false;
    window.ttsStatus.text = text;
    window.ttsStatus.cached = false;
    const response = await axios.get(
      "https://admin.fefdybraingym.com/v1/tts",
      {
        params: { text },
      }
    );
    window.ttsStatus.cached = response.data.data.cached;
    console.log("Response:", response.data);
    console.log("URL:", response.data.data.url);

    currentAudio = new Audio(response.data.data.url);

    currentAudio.onloadedmetadata = () => {
      console.log("Loaded metadata");
    };

    currentAudio.oncanplay = () => {
      console.log("Can play");
    };

    currentAudio.onerror = () => {
      console.log("Audio error");
      console.log(currentAudio.error);
      console.log(currentAudio.src);
    };

currentAudio.onended = () => {
  window.ttsStatus.playing = false;
  window.ttsStatus.finished = true;
};

await currentAudio.play();

} catch (err) {
  window.ttsStatus.playing = false;
  window.ttsStatus.finished = true;

  console.error(err);
}
};